import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { Price } from '../../../../types';
import * as S from './styles';

type OwnProps = {
  className?: string;
  compactText?: boolean;
  deliveryOptions?: Price['deliveryOptions'];
  size?: 'small' | 'normal';
};

const HomeDelivery = ({
  className,
  compactText = false,
  deliveryOptions,
  size = 'normal',
}: OwnProps) => {
  const { t } = useContext(AppContext);

  const homeDelivery =
    deliveryOptions &&
    deliveryOptions.find(option => option && option.type === 'HOME_DELIVERY');

  return homeDelivery ? (
    <S.HomeDelivery className={className}>
      <S.Icon size={16} sizeType={size} />
      <S.Text size={size}>
        {compactText
          ? t('product', 'home-delivery.info-2')
          : t('product', 'home-delivery.info-3')}
      </S.Text>
    </S.HomeDelivery>
  ) : null;
};

export default HomeDelivery;
